module.exports = __webpack_public_path__ + "static/media/syukrina.dbcab050.png";